import type { LineItem, ProductVariant } from '@az/middleware/src/__generated__/gql/graphql';

/**
 * Extracts price in euros/dollars from a price object
 */
function getPriceValue(price?: { value: { centAmount: number } } | null) {
  return price ? price.value.centAmount / 100 : null;
}

/**
 * Gets the discounted price if applicable
 */
function getDiscountedPrice(product: LineItem | ProductVariant): number | null {
  const discount = product.price?.discounted;

  if (product.__typename === 'LineItem') {
    const { discountedPricePerQuantity } = product;
    const discountsLength = discountedPricePerQuantity.length;

    if (discountsLength > 0) {
      return getPriceValue(discountedPricePerQuantity[discountsLength - 1].discountedPrice);
    }
  }

  if (discount?.discount?.isActive) {
    return getPriceValue(discount);
  }

  return null;
}

/**
 * Computes the regular and special price of a product
 */
export function getProductPrice(product: LineItem): { regular: number | null; special: number | null } {
  if (!product) {
    return { regular: null, special: null };
  }

  const quantity = product.__typename === 'LineItem' ? product.quantity : 1;

  const regularPriceSingleItem = getPriceValue(product.price);
  const regularPrice = regularPriceSingleItem !== null ? regularPriceSingleItem * quantity : null;

  const rawSpecial = getDiscountedPrice(product);
  const specialPrice = rawSpecial !== null ? rawSpecial * quantity : null;

  return {
    regular: regularPrice,
    special: specialPrice,
  };
}
